exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-container {\r\n  display: inline;\r\n}\r\n\r\n.image-holder {\r\n  height: 100%;\r\n  width: 100%;\r\n  background-color: #ffffff;\r\n}\r\n\r\n.image-container img {\r\n  height: 100%;\r\n  width: 100%;\r\n  object-fit: contain;\r\n}\r\n\r\n.not-loaded-label {\r\n  width: -webkit-fit-content;\r\n  width: -moz-fit-content;\r\n  width: fit-content;\r\n  margin: auto;\r\n}\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/ETT/Progetti/JumpvNext/Angular/AgentiWebUI/AgentiWebConqordOil.Web.UI/src/app/components/utils/dynamic/components/image/image.component.css
// module id = ../../../../../src/app/components/utils/dynamic/components/image/image.component.css
// module chunks = main